module.exports = __webpack_public_path__ + "img/conference_room_connector.a5df7739.svg";